<template>
  <div role="alert" aria-atomic="true" aria-live="assertive">
    <v-progress-circular
        v-if="isLoading"
        indeterminate
        color="primary"
        :aria-label="$t('Accessibility.page_loading')">
    </v-progress-circular>
    <!--<span v-else class="d-sr-only">{{ $t('Accessibility.page_ready')}}</span>-->
  </div>
</template>
<script>
export default {
  props: ['isLoading'],
}
</script>
